export default {
  title: {
    en: 'Scentbird App',
  },
  subTitle: {
    en: 'Upgrade your beauty & grooming game on-the-go',
  },
  buttonTitle: {
    en: 'Get',
  },
}
